import React from 'react'
import { Flex, Typography, theme } from 'antd'

interface FormSectionProps {
  title: React.ReactNode
  description?: React.ReactNode
  children?: React.ReactNode
}

/** Titled group of related fields on a settings page. */
const FormSection: React.FC<FormSectionProps> = ({ title, description, children }) => {
  const { token } = theme.useToken()

  return (
    <Flex vertical gap={token.marginSM}>
      <Flex vertical gap={token.marginXXS}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        {description && <Typography.Text type="secondary">{description}</Typography.Text>}
      </Flex>
      <div>{children}</div>
    </Flex>
  )
}

export default FormSection
